import { render } from "./BlockedUsersList.vue?vue&type=template&id=57a63148"
import script from "./BlockedUsersList.vue?vue&type=script&lang=js"
export * from "./BlockedUsersList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__